export const PROPERTY_TYPES = ["Riad", "Villa", "Apartment", "Land"];
export const TITLE_STATUSES = ["Titled", "Melkia", "Titling in progress", "Unknown"];
export const LISTING_STATUSES = ["Available", "Under offer", "Sold", "Rented", "Withdrawn", "Pending review"];
export const BEDROOM_OPTIONS = [1, 2, 3, 4, 5, 6];
export const TYPE_COLORS = { Riad: "#e63946", Villa: "#2ec27e", Apartment: "#3b82f6", Land: "#f4b740" };
export const RATES = { MAD: 1, EUR: 1 / 10.8, GBP: 1 / 12.6 };
export const MARRAKECH = [31.6295, -7.9811];

export const titleBadge = (ts) => ({
  Titled: "border-brand-green/40 bg-brand-green/15 text-brand-green",
  "Titling in progress": "border-amber-400/40 bg-amber-400/15 text-amber-300",
  Melkia: "border-white/20 bg-white/10 text-slate-300",
  Unknown: "border-white/10 bg-white/5 text-muted-foreground",
}[ts] || "");

export const statusBadge = (st) => ({
  Available: "bg-brand-green/15 text-brand-green", "Under offer": "bg-amber-400/15 text-amber-300", Sold: "bg-white/10 text-slate-300",
  Rented: "bg-white/10 text-slate-300", Withdrawn: "bg-white/5 text-muted-foreground", "Pending review": "bg-brand-red/15 text-brand-red", Rejected: "bg-white/5 text-muted-foreground",
}[st] || "bg-white/5 text-muted-foreground");

export const fmtPrice = (mad, cur = "MAD") => {
  if (!mad) return "—";
  const v = mad * RATES[cur];
  const sym = { MAD: " MAD", EUR: " €", GBP: " £" }[cur];
  return `${Math.round(v).toLocaleString()}${sym}`;
};

export const EMPTY_FILTERS = { type: "all", titleStatuses: [], quarters: [], areas: [], listing: "all", priceMin: "", priceMax: "", currency: "MAD", beds: "all", status: "all", agent: "all", added: "any", query: "" };

const daysAgo = (iso) => (Date.now() - new Date(iso)) / 86400000;

export function applyFilters(items, f) {
  const toMad = (v) => (v === "" ? null : Number(v) / RATES[f.currency]);
  const min = toMad(f.priceMin), max = toMad(f.priceMax);
  return items.filter((p) => {
    if (f.type !== "all" && p.propertyType !== f.type) return false;
    if (f.type === "Riad" && f.titleStatuses.length && !f.titleStatuses.includes(p.titleStatus || "Unknown")) return false;
    if (f.quarters.length && !f.quarters.includes(p.quarterId)) return false;
    if (f.areas.length && !f.areas.includes(p.areaId)) return false;
    if (f.listing === "sale" && p.listingType !== "purchase") return false;
    if (f.listing === "rent" && p.listingType !== "rental") return false;
    if (f.listing === "shortlet" && !(p.listingType === "rental" && p.shortLetAllowed)) return false;
    const price = p.listingType === "rental" ? p.rentMad : p.priceMad;
    if (min !== null && (price || 0) < min) return false;
    if (max !== null && (price || 0) > max) return false;
    if (f.beds !== "all" && (f.beds === 6 ? (p.beds || 0) < 6 : p.beds !== f.beds)) return false;
    if (f.status !== "all" && (p.listingStatus || "Available") !== f.status) return false;
    if (f.agent !== "all" && p.agentId !== f.agent && !(p.agentIds || []).includes(f.agent)) return false;
    if (f.added === "7" && daysAgo(p.createdAt || p.created_at || Date.now()) > 7) return false;
    if (f.added === "30" && daysAgo(p.createdAt || p.created_at || Date.now()) > 30) return false;
    if (f.query) {
      const q = f.query.toLowerCase();
      if (!`${p.title} ${p.district} ${p.address} ${p.city}`.toLowerCase().includes(q)) return false;
    }
    return true;
  });
}

export const activeChips = (f, ctx) => {
  const t = ctx.t || ((s) => s);
  const chips = [];
  if (f.type !== "all") chips.push({ k: "type", label: t(f.type) });
  f.titleStatuses.forEach((ts) => chips.push({ k: "titleStatuses", v: ts, label: t(ts) }));
  f.quarters.forEach((q) => chips.push({ k: "quarters", v: q, label: ctx.quarterName(q) }));
  f.areas.forEach((a) => chips.push({ k: "areas", v: a, label: ctx.areaName(a) }));
  if (f.listing !== "all") chips.push({ k: "listing", label: t({ sale: "For sale", rent: "For rent", shortlet: "Short-let allowed" }[f.listing]) });
  if (f.priceMin !== "" || f.priceMax !== "") chips.push({ k: "price", label: `${f.priceMin || "0"} – ${f.priceMax || "∞"} ${f.currency}` });
  if (f.beds !== "all") chips.push({ k: "beds", label: `${f.beds}${f.beds === 6 ? "+" : ""} ${t("Beds").toLowerCase()}` });
  if (f.status !== "all") chips.push({ k: "status", label: t(f.status) });
  if (f.agent !== "all") chips.push({ k: "agent", label: ctx.agentName(f.agent) });
  if (f.added !== "any") chips.push({ k: "added", label: t(`Last ${f.added} days`) });
  return chips;
};
